import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import loginSession from './modules/loginSession'
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex)

const debug = false; // process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: debug,

  modules: {
    loginSession
  },

  plugins: debug ? [createLogger()] : [
    createPersistedState({
      key: 'JIPVIO',
      paths: [
        "loginSession",
      ],
      storage: window.sessionStorage,
    }),

  ]
})